import React from 'react'
import { useSpring, animated, SpringConfig } from 'react-spring'
import styled from 'styled-components'

const CompactDrawer = ({
  active,
  width,
  animationConfig,
  compactWidth,
  drawerContent,
  children
}: CompactDrawerProps) => {
  const styleProps = useSpring({
    width: active ? width : compactWidth,
    config: animationConfig
  })

  return (
    <Container>
      <DrawerContainer style={styleProps}>{drawerContent}</DrawerContainer>
      <SlotContainer>{children}</SlotContainer>
    </Container>
  )
}

export type CompactDrawerProps = {
  active: boolean
  width: number
  animationConfig: SpringConfig
  compactWidth: number
  drawerContent: JSX.Element
  children: JSX.Element
}

const Container = styled.div`
  display: flex;
  height: 100vh;
`

const DrawerContainer = styled(animated.aside)`
  height: 100%;
`

const SlotContainer = styled.div`
  height: 100%;
  flex-grow: 1;
`

export default CompactDrawer
